let startHourOptions = [];

for(let hour = -1; hour > -24; hour--) {
  startHourOptions.push({value: hour, text: `${hour > -10 ? `0${-1 * hour}` : -1 * hour}h do dia anterior`});
}

for(let hour = 0; hour < 24; hour++) {
  startHourOptions.push({value: hour, text: `${hour < 10 ? `0${hour}` : hour}h do dia atual`});
}

module.exports = {
  startHourOptions,
}